import { AppConfig } from "@/config/app.config";

/**
 * Get batch-specific configuration with fallback to defaults
 * @param batch - Optional batch identifier. If not provided, uses localStorage or DEFAULT_BATCH
 * @returns Batch configuration object
 */
export const getBatchConfig = (batch?: string) => {
  // Get selected batch from localStorage or use provided batch or default
  const selectedBatch = batch || localStorage.getItem("selectedBatch") || AppConfig.DEFAULT_BATCH;

  // Get the batch config
  const batchConfig = AppConfig.BATCHES[selectedBatch];
  
  if (!batchConfig) {
    console.warn(`Batch "${selectedBatch}" not found, using default batch`);
    return AppConfig.BATCHES[AppConfig.DEFAULT_BATCH];
  }

  return batchConfig;
};

